import React, { Component } from "react";
import { Form, Button, Card, Nav, Tab, Row, Col } from "react-bootstrap";
import Header from "./Header";
import Footer from "./Footer";
import HeaderIntroCompliance from "./HeaderIntroCompliance";
import BusinessRegistrationProcess from "./BusinessRegistrationProcess";
import NewsLetter from "./NewsLetter";
export class BusinessRegistration extends Component {
  render() {
    return (
      <div>
        <Header />
        <div>
          <HeaderIntroCompliance />
        </div>

        <section id="services" class="section-bg"  style={{ backgroundColor: "#f3f9fd" }}>
          <div class="container" data-aos="fade-up">
            <header class="section-header">
              <h3>Business Registration</h3>
              <p>
                At ClipTax, we ensure a smooth entry for you in market, while
                guiding and assisting you through the complex procedures of
                Business Registration. Our focus is on simplifying toilsome
                procedures for incorporation of your business so that you can
                purely concentrate on your business intent. You dream, Cliptax
                executes!
              </p>
              <br />
            </header>

            {/* <Card>
              <Card.Header style={{backgroundColor:"#004767", color:"#fff", fontSize:18}}>Closure/Changes in Business</Card.Header>
              <Card.Body>
             
                <Card.Text style={{color:"#000", fontSize:14, alignSelf:"center"}}>
                    Cliptax can help you easily wind up the company within few
                    months. Cliptax provides additional service of reviewing the
                    status of the company and to decide if the company is ready
                    for winding up or not. Our Professionals will also assist
                    you with all the essential documentation for the process of
                    application to the Ministry of Corporate Finance (MCA)
                    winding up of a company.
                    <br /> 
                    Change is the new constant these days. Cliptax
                    supports your decision to change and helps you for the
                    process of conversion. We provide different services when it
                    comes to making changes for your organization. Be it Adding
                    or Removing a Director or a designated partner; Changing
                    objectives of your business; Changing your name of the
                    company or the official address of the company; changing the
                    course of business or even changing the LLP agreements, we
                    are glad to be of your service. Want a fresh start? Catch up
                    with us now and get solutions to all your problems.
                </Card.Text>
            
              </Card.Body>
            </Card> */}

            

            <div class="row justify-content-center">
              <div
                class="col-md-6 col-lg-6"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box" >
                  {/* <div class="icon">
                    <i
                      class="ion-ios-analytics-outline"
                      style={{ color: "#ff689b" }}
                    ></i>
                  </div> */}
                  <h4 class="title" style={{ color:"#004767", fontSize:18}}>
                    Closure/Changes in Business
                  </h4>
                  <p class="description" style={{ color:"#000", fontSize:14}}>
                    Cliptax can help you easily wind up the company within few
                    months. Cliptax provides additional service of reviewing the
                    status of the company and to decide if the company is ready
                    for winding up or not. Our Professionals will also assist
                    you with all the essential documentation for the process of
                    application to the Ministry of Corporate Finance (MCA)
                    winding up of a company.
                    <br />  Change is the new constant these days. Cliptax
                    supports your decision to change and helps you for the
                    process of conversion. We provide different services when it
                    comes to making changes for your organization. Be it Adding
                    or Removing a Director or a designated partner; Changing
                    objectives of your business; Changing your name of the
                    company or the official address of the company; changing the
                    course of business or even changing the LLP agreements, we
                    are glad to be of your service. Want a fresh start? Catch up
                    with us now and get solutions to all your problems.
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-6"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  {/* <div class="icon">
                    <i
                      class="ion-ios-bookmarks-outline"
                      style={{ color: "#e9bf06" }}
                    ></i>
                  </div> */}
                  <h4 class="title" style={{ color:"#004767", fontSize:18}}>
                    Legal Notices
                  </h4>
                  <p class="description" style={{ color:"#000", fontSize:14}}>
                    Legal Notice to a is a written document sent to someone
                    whether it is a person, company or any other entity, to
                    inform them that you are planning to take a legal action
                    against them. A legal notice is the first step of a legal
                    proceeding that forewarns a person to abide by certain
                    conditions laid out in the legal notice and if the
                    conditions are not followed a legal action would be taken
                    against them. We connect you to our experts and
                    professionals who will work on your notice to prepare a
                    draft after understanding your requirements. In case you
                    want any changes to be made or clarifications to be done,
                    our experts will work on it.
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                    <br />
                  
                  </p>
                </div>
              </div>

              <div
                class="col-md-6 col-lg-6"
                data-aos="zoom-in"
                data-aos-delay="100"
              >
                <div class="box">
                  {/* <div class="icon">
                    <i
                      class="ion-ios-paper-outline"
                      style={{ color: "#3fcdc7" }}
                    ></i>
                  </div> */}
                  <h4 class="title" style={{ color:"#004767", fontSize:18}}>
                    Employment Contracts
                  </h4>
                  <p class="description" style={{ color:"#000", fontSize:14}}>
                    Recruitment of a new employee requires a lot of
                    documentation. Employment contract is very crucial when
                    hiring an employee. It is a written document between the
                    employer and employee defining the rights and
                    responsibilities between the two. An employment contract
                    usually consists: Compensation details, Duration of
                    employment, Roles and responsibilities, Non-compete clause,
                    Notice for termination of the contract and so on. We ensure
                    you that our Experts will help you draft a proper employment
                    contract according to your requirements and demands.
                  </p>
                </div>
              </div>
              <div
                class="col-md-6 col-lg-6"
                data-aos="zoom-in"
                data-aos-delay="200"
              >
                <div class="box">
                  {/* <div class="icon">
                    <i
                      class="ion-ios-speedometer-outline"
                      style={{ color: "#41cf2e" }}
                    ></i>
                  </div> */}
                  <h4 class="title" style={{ color:"#004767", fontSize:18}}>
                    Conversion Documentation
                  </h4>
                  <p class="description" style={{ color:"#000", fontSize:14}}>
                    We not only help you with the conversion of your business
                    but also will assist you in getting the proper
                    documentations for it. We ensure you a hassle free
                    conversion of business along with proper Compliance and
                    Documentation. We even assist you with the changes in the
                    Memorandum of Association. Want a change in business? Get in
                    touch with us now.
                    <br />
                    <br />
                    <br />
                    <br />
                   
                  </p>
                </div>
              </div>
            </div>
          </div>
        </section>
<NewsLetter/>
        <Footer />
      </div>
    );
  }
}

export default BusinessRegistration;
